import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import 'antd/dist/antd.min.css';
import "./Layout/change.css";
import { createHashHistory } from "history";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";
import { createReduxHistoryContext } from "redux-first-history";
import reducers from "./redux/reducers";
import sagas from "./redux/sagas";
import Axios from "axios";
import { persistStore } from "redux-persist";

Axios.defaults.baseURL = window.location.origin.includes(
  "https://mysite.materialdepot.in"
)
  ? "https://api-prod-mysite-new.materialdepot.in/"
  : "https://api-prod-mysite.materialdepot.in/";
Axios.defaults.headers.common.Authorization = localStorage["token"]
  ? `JWT ${localStorage.getItem("token")}`
  : "";
Axios.defaults.headers.post["Content-Type"] = "application/json";

// middlewared
const { routerMiddleware, routerReducer, createReduxHistory } = createReduxHistoryContext({
  history: createHashHistory(),
});

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware, routerMiddleware];
// if (process.env.NODE_ENV === 'development') {
//   middlewares.push(logger)
// }
const store = createStore(
  reducers(routerReducer),
  compose(applyMiddleware(...middlewares))
);
sagaMiddleware.run(sagas);
persistStore(store);

function start() {
  if (window.location.hostname !== "localhost") {
    console.log = () => {};
    console.error = () => {};
    console.debug = () => {};
  }
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById("root")
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

export const routerHistory = createReduxHistory(store);

start();


// version: 1
// frontend:
//   phases:
//     preBuild:
//       commands:
//         - npm ci
//     build:
//       commands:
//         - npm install --legacy-peer-deps
//         - npm run build
//   artifacts:
//     baseDirectory: build
//     files:
//       - '**/*'
// #   cache:
// #     paths:
// #       - node_modules/**/*
